/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'system';
const componentName = 'authentication-config';
const prefix = `${moduleName}.${componentName}`;

export const remoteAuthType = `${prefix}.remoteAuthType`;
export const localAuthType = `${prefix}.localAuthType`;
export const enableLocalUserLoginLabel = `${prefix}.enableLocalUserLoginLabel`;
export const mappingRulesGridHeader = `${prefix}.mappingRulesGridHeader`;

export const ENGLISH = {
    [remoteAuthType]: 'Remote',
    [localAuthType]: 'Local',
    [enableLocalUserLoginLabel]: 'Enable Local User Login',
    [mappingRulesGridHeader]: 'Auth Profiles & Mapping Profiles ({0})',
};
